import { LOGO } from "../../content/site";

export function Wordmark({ variant = "full", className = "", theme = "auto", height = 44 }) {
  const src = variant === "icon" ? LOGO.iconOnly : variant === "text" ? LOGO.wordmarkOnly : LOGO.wordmarkFull;
  return (
    <img
      src={src}
      alt="Altura Global Real Estate"
      style={{ height, width: "auto", maxWidth: "none" }}
      className={`${className} block shrink-0 ${theme === "on-dark" ? "brightness-0 invert opacity-95" : ""}`}
      data-testid="altura-wordmark"
    />
  );
}

export function IconOnly({ size = 40, className = "", theme = "auto" }) {
  return (
    <img src={LOGO.iconOnly} alt="Altura Global"
      style={{ height: size, width: size }}
      className={`${className} ${theme === "on-dark" ? "brightness-0 invert opacity-95" : ""}`}
      data-testid="altura-icon" />
  );
}

export function GoldDivider({ className = "", size = "sm" }) {
  return <span className={`gold-divider ${size === "lg" ? "gold-divider-lg" : ""} ${className}`} aria-hidden="true" />;
}

export function Eyebrow({ children, className = "" }) {
  return <div className={`eyebrow ${className}`}>{children}</div>;
}

export function EditorialHeading({ children, as: Tag = "h2", className = "", size = "lg" }) {
  const sizes = {
    xl: "text-5xl sm:text-6xl lg:text-7xl",
    lg: "text-4xl sm:text-5xl lg:text-[3.25rem]",
    md: "text-3xl sm:text-4xl",
    sm: "text-2xl sm:text-3xl",
  };
  return <Tag className={`editorial-heading ${sizes[size] || sizes.lg} ${className}`}>{children}</Tag>;
}
